module.exports = __webpack_public_path__ + "img/tema-3-18.144e856e.png";